import React from "react";
import { Card } from "reactstrap";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { CleanLine, CleanBar } from "../../charts/campaign/CampaignCharts";
import { Icon } from "../../../Component";

const CampaignInfoCard = ({
  chart,
  chartData,
  title,
  amount,
  change,
  direction,
  theme,
}) => {
  const formatted = new Intl.NumberFormat("es-ES", {});
  return (
    <Card className={`h100 bg-${theme}`}>
      <div className="nk-cmwg nk-cmwg1">
        <div className="card-inner pt-3">
          <div className="d-flex justify-content-between">
            <div className="flex-item">
              <div className="text-white d-flex flex-wrap">
                <span className="fs-2 me-1">{formatted.format(amount)}</span>
              </div>
              <h6 className="text-white">{title}</h6>
            </div>
          </div>
        </div>
        <div className="nk-ck-wrap mt-auto overflow-hidden rounded-bottom">
          <div className="nk-cmwg1-ck">
            {chart === "bar" && chartData  && (
              <CleanBar data={chartData} className="campaign-bar-chart-s1" />
            )}
            {chart === "line" && chartData && (
              <CleanLine data={chartData} className="campaign-line-chart-s1" />
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default CampaignInfoCard;
